import { Component } from '@angular/core'
@Component({
  selector: 'app-admin-register-masteragent',
  templateUrl: './admin-register-masteragent.component.html',
  styleUrls: ['./admin-register-masteragent.component.scss'],
})
export class AdminRegisterMasteragentComponent {}
